import { AxiosApiLayer } from '../../axios-api_layer'

/**
 * postRequestChangePassword
 */

export const postRequestChangePassword = async (
    email: string,
    targetApp: string
): Promise<any> => {
    const axiosApiLayer = AxiosApiLayer.getInstance()
    const data = await axiosApiLayer.post(
        `/password-reset/requestChangePassword`,
        {
            email,
            targetApp,
        }
    )
    return data
}

/**
 * postChangePassword
 */
export const postChangePassword = async (
    email: string,
    token: string,
    password: string,
    confirmPassword: string,
    targetApp: string
): Promise<any> => {
    const axiosApiLayer = AxiosApiLayer.getInstance()
    const data = await axiosApiLayer.post(`/password-reset/changePassword`, {
        email,
        token,
        password,
        confirmPassword,
        targetApp,
    })
    return data
}
